import React, { useState } from "react";
import "./MobileAdvanced.css";
import jsPDF from "jspdf";

const MobileAdvanced = () => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const [mobile, setMobile] = useState("");
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);

  const search = async () => {
    if (!mobile || mobile.length < 10) {
      alert("Enter valid mobile number");
      return;
    }

    setLoading(true);
    setResponse(null);

    try {
      const res = await fetch(
        "https://rcfinder.online/api/mobile_advanced.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            mobile,
            user_id: user.id
          })
        }
      );

      const data = await res.json();

      console.log("API RESPONSE 👉", data);

      if (data.status === "success" && data.data) {
        // ✅ FINAL (DIRECT DATA)
        setResponse(data.data);
      } else {
        alert(data.message || "No data found");
      }

    } catch (err) {
      console.error(err);
      alert("Server error / Network issue");
    }

    setLoading(false);
  };

  /* ===== Recursive JSON Renderer ===== */
  const renderValue = (value, level = 0) => {
    const style = { paddingLeft: level * 18 };

    if (Array.isArray(value)) {
      return value.map((v, i) => (
        <div key={i} style={style} className="json-line">
          {renderValue(v, level + 1)}
        </div>
      ));
    }

    if (typeof value === "object" && value !== null) {
      return Object.entries(value).map(([k, v]) => (
        <div key={k} style={style} className="json-line">
          <span className="json-key">{k} :</span>
          {renderValue(v, level + 1)}
        </div>
      ));
    }

    return (
      <div style={style} className="json-value">
        {String(value)}
      </div>
    );
  };

  /* ===== PDF DOWNLOAD ===== */
  const downloadPDF = () => {
    if (!response) return;

    const doc = new jsPDF("p", "mm", "a4");
    let y = 14;
    const lineHeight = 6;
    const pageHeight = 280;
    const maxWidth = 180;

    doc.setFontSize(14);
    doc.text("Mobile Lookup Report", 10, y);
    y += 10;

    doc.setFontSize(10);

    const writeObject = (obj, indent = 0) => {
      for (const key in obj) {
        if (y > pageHeight) {
          doc.addPage();
          y = 14;
        }

        if (typeof obj[key] === "object" && obj[key] !== null) {
          doc.text(`${" ".repeat(indent)}${key}:`, 10, y);
          y += lineHeight;
          writeObject(obj[key], indent + 4);
        } else {
          const text = `${" ".repeat(indent)}${key}: ${String(obj[key])}`;
          const wrapped = doc.splitTextToSize(text, maxWidth);
          doc.text(wrapped, 10, y);
          y += wrapped.length * lineHeight;
        }
      }
    };

    writeObject(response);
    doc.save(`mobile_lookup_${mobile}.pdf`);
  };

  return (
    <div className="mobile-adv-page">

      <h2 className="mobile-adv-title">📱 Mobile Lookup</h2>
      <p className="mobile-adv-sub">
        Get mobile linked details instantly
      </p>

      <div className="mobile-adv-form">
        <input
          type="text"
          value={mobile}
          maxLength={10}
          onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
          placeholder="Enter mobile number"
        />
        <button onClick={search} disabled={loading}>
          {loading ? "Searching..." : "Search"}
        </button>
      </div>

      {/* ===== RESULT ===== */}
      {response ? (
        <>
          <h3 className="response-title">🔍 Mobile Details</h3>

          <div className="response-box">
            {renderValue(response)}
          </div>

          <button className="pdf-btn" onClick={downloadPDF}>
            📄 Download PDF
          </button>
        </>
      ) : (
        !loading && (
          <p className="no-data">No data to display</p>
        )
      )}

    </div>
  );
};

export default MobileAdvanced;